import React from 'react';

export default React.createContext({
  onFocus: () => { },
  onBlur: () => { },
  onChange: () => { },
  submitForm: () => { },
});
